<template>
  <div>
    <v-btn text small class="mr-2" color="pink" @click="openDialog">
      <v-badge color="red" :content="pending_count" v-if="pending_count > 0">
        <v-icon class="mr-2">mdi-clipboard-check-outline</v-icon> My Tasks
      </v-badge>
      <span v-else>
        <v-icon class="mr-2">mdi-clipboard-check-outline</v-icon> My Tasks
      </span>
    </v-btn>
    <v-dialog v-model="dialog" persistent width="1100">
      <v-card>
        <v-card-title class="py-3">
          <v-icon left color="pink">mdi-clipboard-check-outline</v-icon>
          <span class="text-h6 pink--text">My Tasks</span>
          <v-spacer></v-spacer>
          <v-btn
            v-if="can('route.task_management')"
            small
            color="primary"
            class="mr-2"
            @click="goToTaskManagement"
          >
            <v-icon left small>mdi-view-dashboard</v-icon>
            Task Management
          </v-btn>
          <v-btn icon :loading="refreshing" @click="refreshAll">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4 pb-2">
          <my-tasks-panel ref="tasksPanel" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MyTasksPanel from "./Task/MyTasksPanel.vue";

export default {
  components: { MyTasksPanel },
  computed: {
    ...mapGetters({
      pending_count: "reminder/pending_count",
      user: "auth/user",
      hasPermission: "permission/hasPermission",
      user_permissions: "permission/user_permissions",
    }),
  },
  data() {
    return {
      dialog: false,
      refreshing: false,
    };
  },
  created() {
    this.get_pending_tasks();
  },
  methods: {
    // Hat-based permission gate; accounts without hats get no access.
    can(key) {
      return this.hasPermission(key);
    },
    ...mapActions({
      get_pending_tasks: "reminder/get_pending_tasks",
    }),
    openDialog() {
      this.dialog = true;
    },
    async refreshAll() {
      this.refreshing = true;
      try {
        const panel = this.$refs.tasksPanel;
        if (panel) {
          await panel.refreshAll();
        }
      } finally {
        this.refreshing = false;
      }
    },
    goToTaskManagement() {
      this.dialog = false;
      this.$router.push("/task_management");
    },
  },
};
</script>
